<template>
  <div style="background-color: #ffffff;">
    <h1 style="display: none">Huella hídrica</h1>
    <div class="md-layout md-head-water" >
        <div class="md-layout-item md-small-size-100 mt-4" >
            <h1 class="calcHead head-sellos" style="margin-bottom: 2px !important; margin-top: 15px !important;color: #7691b9; font-size: 3vw;"> ¿SABES CUÁL ES LA HUELLA DE AGUA DE TU ORGANIZACIÓN </h1>
            <h1 class="calcHead head-sellos" style="margin-top: 2px !important; color: #707070;font-size: 3vw;"> O DE LA FABRICACIÓN DE TUS PRODUCTOS?</h1>
            <div>
                <p class="headPara md-small-hide">Todas las actividades que realizamos, los productos y servicios que producimos dejan una huella. Reducir esta huella depende nosotros.</p>
            </div>
        </div>
        <div class="md-layout-item right-side-head md-small-size-100 md-size-35" style="position: relative;">
            <img src="@/assets/WATER-FOOTPRINT.png" alt="Huella de carbono de agua" srcset="" class="head-right-image-seil" >
        </div>
        <div class="md-layout-item md-medium-hide md-small-size-100">
            <p class="headPara">Todas las actividades que realizamos, los productos y servicios que producimos dejan una huella. Reducir esta huella depende nosotros.</p>
        </div>
    </div>
    <div class="md-layout mt-4">
        <div class="md-layout-item md-size-50 md-small-hide mt-4" style="background-color: #ffffff;">
            <img src="@/assets/water-graph.png" alt="Graficos de agua" srcset="" style="background-color: #ffffff;">
        </div>
        <div class="md-layout-item md-small-size-100  water-footprint-detail">
            <h1>¿QUE ES LA HUELLA DEL AGUA?</h1>
            <p>Es la métrica o métricas con las que se cuantifican los impactos ambientales potenciales relacionados con el agua.</p>
            <p>
            La huella del agua se cuantifica siguiendo un completo Análisis de Ciclo de Vida (ACV) definido por la Norma Internacional ISO 14044 e ISO 14046.
            </p>
        </div>
        <div class="md-layout-item  md-small-size-100 md-medium-hide mt-4" style="background-color: #ffffff;">
            <img src="@/assets/water-graph.png" alt="Graficos de agua" srcset="" style="background-color: #ffffff;">
        </div>
    </div>
    <Cuadro />
  </div>
</template>

<script>
import Cuadro from '../components/CuadroWater'
export default {
     metaInfo: {
        title: 'Calcula tu huella hídrica | Green Solutions',
        meta: [
            { name: 'description', content: 'Gestiona tu Huella Hídrica con Green Solutions | Reducción del consumo de agua y eficiencia en la producción. Promovemos la gestión sostenible del agua y la protección de los recursos hídricos. Descubre cómo minimizar tu impacto y contribuir a la conservación del medio ambiente. Contáctanos hoy mismo.' }
        ]
    },
    components: {Cuadro}
}
</script>

<style>
.md-head-water {
    padding: 2vw 0 4vw 6vw;
}
.water-footprint-detail {
    background-color: #7691b9; 
    color: #ffffff;
    padding: 3rem 5rem 3rem 4rem;
    text-align: justify;
}
.water-footprint-detail h1 {
    font-size: 3vw;
    font-weight: bold;
    line-height: 1.18;
}
.water-footprint-detail p {
    letter-spacing: -0.56px;
    line-height: 1.18;
    font-size: 1.5vw;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.54;
    letter-spacing: -0.56px;
}
</style>